import { useQuery } from "@tanstack/react-query"
import { setQueryCache, vacationBalancesAPI } from "@/utils"

export function useVacationBalances(userIds?: string[]) {
  const ids = userIds ? [...new Set(userIds)].sort() : undefined
  return useQuery({
    queryKey: ["/vacation/balances", ids ?? "all"],
    queryFn: () => vacationBalancesAPI.fetch(ids),
    enabled: ids === undefined || ids.length > 0,
    ...setQueryCache(60e3),
  })
}
